import axiosInstance from "./axiosConfig";
import { handleApiError } from "./errorHandler";

export const cuz_drive_start = async (data) => {
    try {
        const response = await axiosInstance.get(`/api/adminProgram`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'cuz_drive_start');
    }
};

export const check_status_massage = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/check_test_availablity`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'check_status_massage');
    }
};

export const delete_test = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/delete_test`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'delete_test');
    }
};

export const initial_step = async (data) => {
    try {
        console.log("initial_step", data);
        const response = await axiosInstance.post(`/api/initialStep`, data);
        console.log(response, "=======++-+-+-+---+-+-");
        return response;
    } catch (error) {
        throw handleApiError(error, 'initial_step');
    }
};

export const response_solution = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/response`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'response_solution');
    }
};

export const reverse_response = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/revresponse`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'reverse_response');
    }
};
